<template>
    <div class="searching-page child-view">
        <div class="search-container">
            <Search
                :searching="true"
            />
        </div>
        <div class="history-container">
            <SearchHistory/>
        </div>
    </div>
</template>

<script>
// components
import Search from '@/components/Search'
import SearchHistory from '@/components/SearchHistory'

export default {
    components: {
        Search,
        SearchHistory
    }
}
</script>

<style lang="less" scoped>
.searching-page {
    .search-container {
        padding: 13px 15px;
        border-bottom: 8px solid #F2F2F2;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Searching/index.vue